<template>
    <v-container fluid>
        <sensor-list></sensor-list>
    </v-container>
</template>

<script>
import SensorList from '../sensor/components/SensorList'

export default {
  name: 'Dashboard',
  components: {SensorList},
}
</script>

<style lang="scss"></style>
